import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import DeleteOutlineIcon from "static/icons/delete_black_24dp.svg"

const DeleteIcon = (props: IconWrapperIconProps) => {
  const name = "delete"
  return (
    <IconWrapper name={name} {...props}>
      <DeleteOutlineIcon/>
    </IconWrapper>
  )
}

export default DeleteIcon
